// extracted by mini-css-extract-plugin
module.exports = {"workspaceMenu":"WorkspaceMenuStyles_workspaceMenu__uw7dP","currentWorkspaceArrow":"WorkspaceMenuStyles_currentWorkspaceArrow__ttrpB"};